import { useRef } from "react";
import { Image } from "react-datocms";
import React from "react";
import { CodeWindow } from "./CodeFeatureTabs";
import { COLORS } from "../helpers";
import { Flex } from "@radix-ui/themes";

export const GoldRushComponentSwitch = ({ children, dark = false }) => {
    return <div className={"wrapper " + (dark && "dark")}>
        <div className="switch">
            {children}
        </div>
        <style jsx>
            {`
            .switch {
                padding: var(--landing-page-padding);
                max-width: var(--landing-page-max-width);
                margin: 0 auto;
                min-height: 50vh;
                display: flex;
                flex-direction: column;
                // gap:3rem;
                gap: var(--space-3);
                justify-content: space-between;
            }
            .wrapper {
                background: #f5f5f5;
            }
            .wrapper.dark {
                background: var(--covalent-dark-blue);
                color: #fff;
            }
            @media (max-width: 768px) {
                .switch {
                    gap:1rem;
                }
            }

        `}
        </style>
    </div>;
};


export const GoldRushTabContent = ({ children, dark = false }) => {
    return <div className={"wrapper " + (dark && "dark")}>
        <div className="switch">
            {children}
        </div>
        <style jsx>
            {`
            .switch {
                display: flex;
                //gap:3rem;
                gap: var(--space-3);
                justify-content: space-between;
            }
            .wrapper {
                background: #f5f5f5;
            }
            .wrapper.dark {
                background: var(--covalent-dark-blue);
                color: #fff;
            }
            @media (max-width: 1040px) {
             
                .switch-wrapper{
                    flex-direction:column;
                    gap:0;
                }
                .switch {
                    flex-direction:column;
                    justify-content:center;
                    border-top: 1px solid #DCDADA;
                }
            }
        `}
        </style>
    </div>;
};

export const GoldRushCustomContent = ({ children, dark = false }) => {
    return <div className={"wrapper " + (dark && "dark")}>
        <div className="switch">
            {children}
        </div>
        <style jsx>
            {`
            .switch {
                display: flex;
                gap:3rem;
                justify-content: space-between;
                padding-bottom:4rem;
            }
            .wrapper {
                background: #f5f5f5;
            }
            .wrapper.dark {
                background: var(--covalent-dark-blue);
                color: #fff;
            }
            @media (max-width: 1040px) {
             
                .switch-wrapper{
                    flex-direction:column;
                    gap:0;
                }
                .switch {
                    flex-direction:column;
                    justify-content:center;
                    padding-top:2.5rem;
                    
                }
            }
        `}
        </style>
    </div>;
};

export const GoldRushComponentSwitchLeft = ({ children }) => {
    return <><div className="switchleft">
        {children}
    </div><style jsx>{`
         .switchleft {
            display:flex;
            height:100%;
            align-items:flex-start;
            flex-direction:column;
            margin-top:2rem;
            flex:1.2;
         }
         @media (max-width: 1040px) {
             .switchleft-wrapper{
                 flex-direction:column;
                 gap:0;
             }
             .switchleft {
                 justify-content:center;
             }
         }
     `}</style></>;
};

export const GoldRushComponentSwitchRight = ({ children }) => {
    return <><div className="switchright">
        {children}
    </div><style jsx>  {`
         .switchright {
             flex:2.2;
             gap:2rem;
             display: flex;
             flex-direction: column;
             position:relative;

         }
         @media (max-width: 600px) {
             .switchright-wrapper{
                 flex-direction:column;
                 gap:0;
             }
             .switchright {
                 justify-content:center;
                 
             }
         }
     `} </style></>;
};

export const GoldRushComponentCustomLeft = ({ children }) => {
    return <><div className="switchleft">
        <Flex gap="6" direction={"column"}>
            {children}
        </Flex>
    </div><style jsx>{`
         .switchleft {
            // display:flex;
             height:100%;
             align-items:flex-start;
            // flex-direction:column;
             margin-left:4.5rem;
             flex:1;
         }
         @media (max-width: 1040px) {
             .switchleft {
                 margin-left:0rem;
                // margin-top:2rem;
                 justify-content:center;
             }
         }
     `}</style></>;
};

export const GoldRushComponentCustomRight = ({ children }) => {
    return <><div className="switchright">
        {children}
    </div><style jsx>  {`
         .switchright {
             flex:2.2;
             gap:2rem;
             display: flex;
             flex-direction: column;
             position:relative;

         }
         @media (max-width: 600px) {
             .switchright-wrapper{
                 flex-direction:column;
                 gap:0;
             }
             .switchright {
                 justify-content:center;
                 
             }
         }
     `} </style></>;
};


export const GoldRushSectionTitle = ({ children }) => {

    return <>
        <h2>
            {children}
        </h2>
        <style jsx>
            {`
            h2 {
                font-size: var(--font-size-6);
                line-height: 1.2;
            }
            .benefits__title__on__screen {
                animation: fadeIn 0.5s ease-in-out forwards;
            }
        `}
        </style>
    </>;
};


export const GoldRushTitle = ({ children }) => {

    return <><h3>
        {children}
    </h3>  <style jsx>  {`
            h3 {
                font-size: var(--font-size-5);
             //   margin-bottom: 1rem;
                line-height: 1.2;
              //  font-weight: 200;
            }
            .benefits__title__on__screen {
                animation: fadeIn 0.5s ease-in-out forwards;
            }
        `} </style>
    </>;
};

export const GoldRushDescription = ({ children }) => {

    return (
        <p className="goldrush__subtitle">{children}
            <style jsx>{`
            .goldrush__subtitle {
            }
            @media (max-width: 1040px) {
                div {
                    flex-direction: column;
                    place-items: start;
                }
                .goldrush__subtitle {
                    max-width: 100%;
                }
            }
        `}</style></p>
    );
};
export const GoldRushSubtitle = ({ children }) => {
    return <>
        <h3>
            {children}
        </h3>
        <style jsx>
            {`
h3 {
    margin-bottom: 1rem;
}
`}
        </style>
    </>;

};

export const GoldRushButtonList = ({ children }) => {
    return (
        <div className="benefits__cards">{children}
            <style jsx>{`
            div {
                display: flex;  
                flex-direction: row;
                justify-content: start;
                gap: var(--landing-page-gap);
            }
            @media (max-width: 768px) {
                div {
                    flex-direction: column;
                    place-items: start;
                }
            }
        `}</style></div>
    );
};

export const GoldRushColorList = ({setColor}) => {
    const color500Array = Object.keys(COLORS).map((key) => [
        key,
        COLORS[key]["500"],
    ]);
    return (
        <>
            <div  className="color__list">
                {color500Array.map((o, i) => {
                    return <div style={{background: o[1]}} key={i} className="color-select" onClick={()=>{
                        setColor(o[1]);
                    }}/>;
                })}
            </div>
            <style jsx>{`
            .color__list {
                display:flex;
                flex-wrap: wrap;
                gap:10px;
              //  margin: 2rem 0 1rem 0;
            }
            .color-select{
                background:black;
                width:35px;
                height:35px;
                border-radius: 100%;
                cursor:pointer;

            }
            .color-select:hover{
                box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
                border: 2px solid white;
                padding:15px;
            }
            @media (max-width: 768px) {
                color__list{
                    margin: 0;
                }
            }
        `}</style></>
    );
};


export const GoldRushComponentImage = ({ src }) => {
    const animatedRef = useRef<HTMLDivElement>(null);

    return <>
        <div ref={animatedRef} className="goldrush-component-image">
            <Image usePlaceholder={false} data={src} className="" />
        </div>
        <style jsx>
            {`
            :global(.goldrush-component-image) {
                border-radius:var(--border-radius)!important;
                padding:0.5rem;
                background:white;
                box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);

            }
        `}
        </style>
    </>;
};


export const GoldRushHeroCode = ({ code }) => {

    const packageManagers = [
        {
            title: "npm",
            code: `npm install ${code}`
        },  
        {
            title: "yarn",
            code: `yarn add ${code}`
        }];

    return <>
        <div className="hero-code">
            <div className="code__feature__container dark">
                <div className="code__section">
                    <CodeWindow tabs={packageManagers}/>
                </div>
            </div>
        </div>

        <style jsx>{`
            .hero-code{
                max-width:30rem;

            }
            .token.string, .token.number, .token.boolean, .token.null {
                color:red!important;
            }
            :global(.code__feature__tabs .variable) {
                color: var(--pink);
            }

            .code__feature__container{
                margin: 1rem 0 2rem 0;

            }

            .result__code {
                
                white-space: pre;
                color: var(--text);
                font-family: var(--mono);
                overflow: hidden;
                padding: 1rem;
                max-height: 220px;
                font-size: var(--font-size-1);
                overflow: hidden;
                max-height: 265px;
                width: 100%;
                margin-left: auto;
                max-with: 100%;
                min-width: 550px;
            }

            .code__section {
               position: relative;
               width: 100%;
               max-width:40rem;
               gap: 1.5rem;
               display: flex;
               flex-direction: column;
               flex: 1;
            }
            h2 {
                line-height: 1.2;
                font-size: var(--font-size-7);
                color: var(--text);
                font-weight: 200;
                margin-bottom: 1rem;
            }
            p {
                color: var(--text);
            }
            .code__feature__content {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                margin-top: 5rem;
                gap: 5rem;
                position: inherit;
                z-index: 10;
            }
            .code__feature__inner {
                width: 100%;
                padding: var(--landing-page-padding);
                margin: 0 auto;
            }
            @media (max-width: 768px) {
                :global(.code__feature__tabs .tab-list) {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    border: none;
                }
                :global(.code__feature__tabs .tab-list-item) {
                    width: max-content;
                }
                :global(.code__feature__tabs .tab-list-item:hover) {
                    background: var(--code-background);
                    border-bottom: none;
                }
                :global(.code__feature__tabs .tab-list-item.tab-list-active) {
                    border-left: 2px solid var(--pink);
                    border-bottom: none;
                    background: var(--code-background);
                }
                .code__feature__content {
                    margin-top: 2rem;
                    gap: 3rem;
                }
        `}</style></>;
};


export const GoldRushCode = ({ code }) => {

    return <><div className="code__feature__container dark">
        <div className="code__feature__inner">
            <div className="code__feature__tabs">
                <div className="code__feature__content">
                    <div className="code__section">
                        <CodeWindow tabs={code}/>
                    </div>
                </div>
            </div>
        </div>
    </div><style jsx>{`
            .token.string, .token.number, .token.boolean, .token.null {
                color:red!important;
            }
            .code__feature__container {
                position: absolute;
                bottom:-120px;
                right: -120px;
                display: flex;
                place-items: center;
            }
            .code__feature__tabs {
               width: max-content;
               max-width: 100%;
            }

            :global(.code__feature__tabs .variable) {
                color: var(--pink);
            }

    
            .result__code {
                white-space: pre;
                color: var(--text);
                font-family: var(--mono);
                overflow: hidden;
                padding: 1rem;
                max-height: 450px;
                font-size: var(--font-size-1);
                overflow: hidden;
                max-height: 265px;
                width: 100%;
                margin-left: auto;
                max-with: 100%;
                min-width: 550px;
                min-height: 265px;
            }
            .code__box {
                white-space: pre-wrap;
                color: var(--pink);
                font-family: var(--mono);
                overflow: hidden;
                padding: 1rem;
                border-bottom: none; 
                font-size: var(--font-size-1);
                z-index: 10;
                width: 100%;
            }
            .code__section {
               position: relative;
               width: 100%;
               max-width:40rem;
               gap: 1.5rem;
               display: flex;
               flex-direction: column;
               flex: 1;
            }

            .code__feature__content {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
                margin-top: 5rem;
                gap: 5rem;
                position: inherit;
                z-index: 10;
            }
            .code__feature__inner {
                width: 100%;
                padding: var(--landing-page-padding);
                margin: 0 auto;
            }
            @media (max-width: 1040px) {
                .result__code{
                    max-width:30rem;
                    max-height:10rem;
                    min-height:10rem;
                    min-width:10rem;
                }
            }
            @media (max-width: 768px) {
                :global(.code__feature__tabs .tab-list) {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                    border: none;
                }
                :global(.code__feature__tabs .tab-list-item) {
                    width: max-content;
                }
                :global(.code__feature__tabs .tab-list-item:hover) {
                    background: var(--code-background);
                    border-bottom: none;
                }
                :global(.code__feature__tabs .tab-list-item.tab-list-active) {
                    border-left: 2px solid var(--pink);
                    border-bottom: none;
                    background: var(--code-background);
                }
                .code__feature__content {
                    margin-top: 2rem;
                    gap: 3rem;
                }
        `}</style></>;
};